/**
 * Innehåller data för att skapa ett TreeView-filter för en rapport
 */
import { TranslateService } from '@ngx-translate/core';

import { ParamData } from './param-data';
import { ServerTreeViewData } from "./server-tree-view-data";
import { CheckboxTreeviewItem } from './checkbox-treeview-item';

export abstract class TreeViewDataBase {
    constructor(
        public id: string,
        public title: string
    )
    { }

    public abstract setItems(paramData: ParamData, collapseFirstLevel?: boolean);
    public abstract updatingParam: boolean;
    public abstract getParamPresentation(): ParamPresentation;

    /**
     * Skapar TreeView första nivån
     * @param text
     * @param value
     * @param datagroup
     * @param paramData
     */
    public getTreeViewItem(text: string, value: string, datagroup, paramData, collapseFirstLevel: boolean = false): CheckboxTreeviewItem {
        var collapseSubLevels = true;
        let match;
        paramData.data.forEach((data) => {
            if (data.toString() === value) {
                match = data;
            }
        });
        return new CheckboxTreeviewItem({
            text: text,
            value: value,
            children: (() => {
                if (datagroup.length > 0) {
                    return this.getChildren(datagroup, collapseSubLevels, paramData);
                }
                return null;
            })(),
            collapsed: collapseFirstLevel,
            checked: match ? true : false
        });
    }

    /**
     * Skapar TreeView children
     * @param datagroup
     * @param collapsed
     * @param paramData
     */
    public getChildren(datagroup, collapsed: boolean, paramData: ParamData): CheckboxTreeviewItem[] {
        let children = [];
        datagroup.forEach((obj: ServerTreeViewData) => {

            let childrenItem = this.createTreeViewChildrenItem(obj, collapsed, paramData);

            if (obj.Children != null) {
                let subChildren = [];
                obj.Children.forEach((subObj: ServerTreeViewData) => {
                    let subChildrenItem = this.createTreeViewChildrenItem(subObj, collapsed, paramData);
                    if (subObj.Children != null) {
                        let subSubChildren = [];
                        subObj.Children.forEach((subSubObj: ServerTreeViewData) => {
                            let subSubChildrenItem = this.createTreeViewChildrenItem(subSubObj, collapsed, paramData);
                            subSubChildren.push(subSubChildrenItem);
                        });
                        subChildrenItem.children = subSubChildren;
                    }
                    subChildren.push(subChildrenItem);
                });
                childrenItem.children = subChildren;
            }

            children.push(childrenItem);
        });
        return children;
    }

    /**
     * Skapar TreeView Children Items
     * @param obj
     * @param collapsed
     * @param paramData
     */
    public createTreeViewChildrenItem(obj: ServerTreeViewData, collapsed: boolean, paramData: ParamData) {
        let match;
        paramData.data.forEach((data) => {
            if (data.toString() === obj.Key) {
                match = data;
            }
        });
        return new CheckboxTreeviewItem({
            text: obj.Value,
            value: obj.Key,
            checked: (() => {
                if (match) {
                    collapsed = false;
                    return true;
                } else {
                    return false;
                }
            })(),
            collapsed: collapsed
        });
    }
}

export class ParamPresentation {
    constructor(
        public id: string,
        public title: string,
        private data: ParamPresentationData[]
    ) { }

    public getParamData(): ParamPresentationData[] {
        return this.data;
    }

    public getParamDataOutput(paramData: ParamData): string {
        let output = "";
        let paramDataStrings = [];
        paramData.data.forEach((data) => { paramDataStrings.push(data.toString()); });
        this.data.forEach((data) => {
            if (paramDataStrings.indexOf(data.key) > -1) {
                output += `<span class='param-press-data'>${data.value}</span>, `;
            }
        });
        output = output.slice(0, -2); //Ta bort sista kommatecknet.
        return output;
    }

    public getKeyFromValue(value: string): string {
        let result;
        this.data.forEach((param) => {
            if (param.value === value) {
                result = param.key;
            }
        });
        return result;
    }

    public getAllKeys(): string[] {
        let result = [];
        this.data.forEach((data) => {
            result.push(data.key);
        });
        return result;
    }
}

export class ParamPresentationData {
    constructor(
        public key: string,
        public value: string
        ) { }
}
